<app-modal [title]="'User Sessions'" [(visible)]="visible" [size]="'large'" [close]="false">
    <div #modalContent class="d-flex flex-column gap-3" ngProjectAs="modal-content">

        <span>You've reached your limit of <span class="font-semibold">{{userMaxSessions()}}</span> active sessions. To continue, sign out of another device below:</span>

        @let authSessions = userSessions();
        @if(authSessions){
            <app-session-list
                [rowData]="userSessions()"
                [features]="features().SessionList"
                (click-action)="onActionClicked($event)"
                [(refresh)]="refresh$"
            />
        }
        
    </div>
</app-modal>